/**
 * Legacy PhotosApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.photosApi`) keep resolving.
 *
 * The actual PhotosApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/photos/photos-api.service.ts
 */
angular.module("acme.common.service.photosApi", []);
